import { apiClient } from '@/to-fsd/shared/api';

export const getClientFile = (clientId, fileId) => {
  return apiClient.get(`/merchant/core/clients/clients/${clientId}/files/${fileId}`);
};

export const getClientFiles = clientId => {
  return apiClient.get(`/merchant/core/clients/clients/${clientId}/files`);
};

export const uploadClientFileByUuid = formData => {
  return apiClient.post(`/merchant/core/clients/qr/files`, formData);
};
